import React, { useState } from 'react';
import { Input } from 'antd';
import { InputContainer, InputItem } from '../../../StyledComponents/Common';


const SimpleInput = (props) => {


  return (
    <InputContainer wd={props.wd}>
      <InputItem
            id={props.name}
            placeholder={props.placeholder}
            name={props.name}
            type={props?.type||"text"}
            value={props.value}
            onChange={(e)=> props.handleChange(e)}
            size={props.size}
        />
    </InputContainer>
  );
};

export default SimpleInput;
